import { render, staticRenderFns } from "./PurchaseHub.vue?vue&type=template&id=1c60d224&scoped=true&lang=pug&"
import script from "./PurchaseHub.vue?vue&type=script&lang=js&"
export * from "./PurchaseHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c60d224",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
